import React, { useState } from 'react';
import { TooltipWrapper, TooltipContent, IconWrapper } from './styles';
import { InfoCircleIcon } from '../Icons';
import { IAdobeClickEvent } from '../../../types/tracking';
import sendEvent from '../../../utils/sendEvent';

interface ITooltipProps {
  children: React.ReactNode;
  alignHorizontal?: 'left' | 'center' | 'right';
  alignVertical?: 'top' | 'middle' | 'bottom';
  backgroundColor?: string;
  tracking?: IAdobeClickEvent;
  trackingType?: string;
}

const Tooltip = ({
  alignHorizontal = 'center',
  alignVertical = 'bottom',
  backgroundColor,
  children,
  tracking,
  trackingType = 'impressionevent',
}: ITooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  const displayTooltipWithEvent = () => {
    if (tracking && !isVisible) {
      sendEvent(tracking, trackingType);
    }
    setIsVisible(true);
  };

  return (
    <TooltipWrapper
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => displayTooltipWithEvent()}
      onBlur={() => setIsVisible(false)}
    >
      <IconWrapper onMouseEnter={() => displayTooltipWithEvent()}>
        <InfoCircleIcon />
      </IconWrapper>
      <TooltipContent
        alignHorizontal={alignHorizontal}
        alignVertical={alignVertical}
        isVisible={isVisible}
        backgroundColor={backgroundColor}
        dangerouslySetInnerHTML={{ __html: children as string }}
      />
    </TooltipWrapper>
  );
};

export default Tooltip;
